import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { createUser, getRoles } from "services/users/calls"
import {
  Alert,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  Row,
  Spinner,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import { cpf } from "cpf-cnpj-validator"
import toast from "components/Toast/Toast"
import { getAllChannels } from "services/support/calls"

const NewUser = props => {
  const [isLoading, handleLoading] = useState(true)
  const [roles, setRoles] = useState([])
  const [user, setUser] = useState({})
  const [modalOpen, setModalOpen] = useState(false)
  const [channels, setChannels] = useState([])

  const fetchRoles = async () => {
    try {
      const res = await getRoles()
      const { roles } = res.payload
      setRoles(roles)
    } catch (err) {
    } finally {
      handleLoading(false)
    }
  }

  const fetchChannels = async () => {
    try {
      const canais = await getAllChannels()
      setChannels(canais)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchChannels()
    fetchRoles()
  }, [])

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      login: "",
      email: "",
      role: undefined,
      isMfaEnabled: false,
    },
    validationSchema: Yup.object().shape(
      {
        login: Yup.string()
          .min(3, "Login muito pequeno")
          .max(50, "Máximo de 50 caracteres permitido para Login.")
          .required("Campo usuário é obrigatório."),
        role: Yup.string().required("Campo tipo de acesso é obrigatório"),
        name: Yup.string()
          .min(3, "Nome muito pequeno")
          .max(255, "Máximo de 255 caracteres permitido para Nome.")
          .required("Campo nome é obrigatório."),
        email: Yup.string()
          .email("Campo e-mail deve conter um e-mail válido.")
          .required("Cempo e-mail é obrigatório."),
        documentId: Yup.string()
          .notRequired()
          .nullable()
          .when("documentId", {
            is: value => value?.length,
            then: rule =>
              rule.test("", "CPF inválido", value => cpf.isValid(value)),
          }),
      },
      [["documentId", "documentId"]]
    ),
    onSubmit: async (values, { resetForm }) => {
      if (isLoading) return
      handleLoading(true)
      try {
        const { payload } = await createUser(values)
        setUser(payload?.accesses)
        toast("success", "Usuário criado com sucesso!", "")
        resetForm()
      } catch (error) {
        toast("error", error?.message, error?.title || "Erro")
      } finally {
        handleLoading(false)
      }
    },
  })

  // useEffect(() => {
  //   setUser(props.user)
  //   setModalOpen(props.user ? true : false)
  // }, [props.user])

  return (
    <React.Fragment>
      <Row>
        <p>Crie um novo usuário para ter acesso ao sistema</p>
      </Row>
      <Row>
        <Form
          className="form-horizontal"
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Label className="form-label">Dados de Acesso</Label>
            <Row>
              <Col sm={6}>
                <Input
                  name="login"
                  className="form-control"
                  placeholder="Usuário"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.login || ""}
                  invalid={
                    validation.touched.login && validation.errors.login
                      ? true
                      : false
                  }
                  autoComplete="off"
                />
                {validation.touched.login && validation.errors.login ? (
                  <FormFeedback type="invalid">
                    {validation.errors.login}
                  </FormFeedback>
                ) : null}
              </Col>
              <Col sm={4}>
                <Input
                  name="role"
                  className="form-control"
                  placeholder="Tipo de Acesso"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.role || ""}
                  invalid={
                    validation.touched.role && validation.errors.role
                      ? true
                      : false
                  }
                >
                  <option value={""}>Tipo de Acesso</option>
                  {roles.map(role => (
                    <option value={role.id} key={`role-${role.id}`}>
                      {role.name}
                    </option>
                  ))}
                </Input>
                {validation.touched.role && validation.errors.role ? (
                  <FormFeedback type="invalid">
                    {validation.errors.role}
                  </FormFeedback>
                ) : null}
              </Col>
              <Col>
                <div className="mb-3 form-check form-switch form-switch-lg">
                  <Input
                    name="isMfaEnabled"
                    type="checkbox"
                    className="form-check-input my-0"
                    style={{ marginLeft: "0px" }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.isMfaEnabled || false}
                    checked={validation.values.isMfaEnabled || false}
                    invalid={
                      validation.touched.isMfaEnabled &&
                      validation.errors.isMfaEnabled
                        ? true
                        : false
                    }
                  />
                  <Label className="form-check-label">
                    Autenticador Google?
                  </Label>
                  {validation.touched.isMfaEnabled &&
                  validation.errors.isMfaEnabled ? (
                    <FormFeedback type="invalid">
                      {validation.errors.isMfaEnabled}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              {/* <Col>
                <Input
                  name="channel"
                  className="form-control"
                  placeholder="Canal de Atendimento"
                  type="select"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.channel || ""}
                  invalid={
                    validation.touched.channel && validation.errors.channel
                      ? true
                      : false
                  }
                >
                  <option value={""}>Canal de Atendimento</option>
                  {channels.map(channel => (
                    <option value={channel.id} key={`channel-${channel.id}`}>
                      {channel.name}
                    </option>
                  ))}
                </Input>
                {validation.touched.channel && validation.errors.channel ? (
                  <FormFeedback type="invalid">
                    {validation.errors.channel}
                  </FormFeedback>
                ) : null}
              </Col> */}
            </Row>
          </div>
          <div className="mb-3">
            <Label className="form-label">Dados Pessoais</Label>
            <Input
              name="name"
              className="form-control"
              placeholder="Nome Completo"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
              autoComplete="off"
            />
            {validation.touched.name && validation.errors.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </div>
          <div className="mb-1">
            <Row>
              <Col>
                <Input
                  name="email"
                  className="form-control"
                  placeholder="E-mail"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                  invalid={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                  autoComplete="off"
                />
                {validation.touched.email && validation.errors.email ? (
                  <FormFeedback type="invalid">
                    {validation.errors.email}
                  </FormFeedback>
                ) : null}
              </Col>
              <Col>
                <Input
                  name="documentId"
                  className="form-control"
                  placeholder="CPF (opcional)"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.documentId || ""}
                  invalid={
                    validation.touched.documentId &&
                    validation.errors.documentId
                      ? true
                      : false
                  }
                  autoComplete="off"
                />
                {validation.touched.documentId &&
                validation.errors.documentId ? (
                  <FormFeedback type="invalid">
                    {validation.errors.documentId}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
          </div>
          {isLoading && (
            <div className="mt-3" style={{ textAlign: "center" }}>
              <Spinner className="ms-2" color="primary" />
            </div>
          )}
          {!isLoading && (
            <div className="mt-3 d-grid">
              <button
                className="btn btn-primary btn-block"
                type="submit"
                disabled={isLoading}
              >
                Cadastrar
              </button>
            </div>
          )}
        </Form>
      </Row>
      {/*<Modal
        isOpen={modalOpen}
        toggle={() => {
          setModalOpen(!modalOpen)
        }}
        centered
        onClosed={() => {
          setUser({})
          props.setReRenderList(!props.reRenderList)
          props.setNav(0)
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>
              Usuário {user?.name} cadastrado com sucesso! Anote o login e a
              senha do usuário, esta senha so aparece uma vez.
            </p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalOpen(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h5>{`Login : ${user?.login}`}</h5>
          <h5>{`Senha : ${user?.password}`}</h5>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalOpen(false)
            }}
            className="btn btn-secondary "
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
        </div>
      </Modal>*/}
    </React.Fragment>
  )
}

NewUser.propTypes = {
  t: PropTypes.any,
  reRenderList: PropTypes.bool,
  setReRenderList: PropTypes.func,
  setNav: PropTypes.func,
}

export default withTranslation()(NewUser)
